module.exports = __webpack_public_path__ + "static/img/200161.3c0dda22.png";